module.exports = __webpack_public_path__ + "static/book-heart-23d7832c506a5d07efc322f773b97b8f.jpg";